export const CONTACT = 1
export const MERCHANT = 2
export const SHIPPERS = 3
export const TRUCK_SALES_DEALER = 4
export const FINANCE_DEALER = 5

export const contactCategoryOptions = [
  { id: 1, name: 'Contact' },
  { id: 2, name: 'Merchant' },
  { id: 3, name: 'Shipper' },
  { id: 4, name: 'Truck Sales Dealer' },
  { id: 5, name: 'Finance Dealer' },
]
